/* eslint-disable no-await-in-loop */
import { wait } from './helpers.js';

async function withIframe(action, initialHtml, domPollInterval = 50) {
    // Дожидаемся, пока появится body, чтобы можно было вставить iframe.
    while (!document.body) {
        await wait(domPollInterval);
    }

    const iframe = document.createElement('iframe');

    try {
        await new Promise((resolve, reject) => {
            let isComplete = false;
            const resolveFn = () => {
                isComplete = true;
                resolve();
            };
            const rejectFn = error => {
                isComplete = true;
                reject(error);
            };

            iframe.onload = resolveFn;
            iframe.onerror = rejectFn;
            const { style } = iframe;
            style.setProperty('display', 'block', 'important');
            style.position = 'absolute';
            style.top = '0';
            style.left = '0';
            style.visibility = 'hidden';
            if (initialHtml && 'srcdoc' in iframe) {
                iframe.srcdoc = initialHtml;
            } else {
                iframe.src = 'about:blank';
            }
            document.body.appendChild(iframe);

            const checkReadyState = () => {
                if (isComplete) {
                    return;
                }

                if (iframe.contentWindow?.document?.readyState === 'complete') {
                    resolveFn();
                } else {
                    setTimeout(checkReadyState, 10);
                }
            };
            checkReadyState();
        });

        while (!iframe.contentWindow?.document?.body) {
            await wait(domPollInterval);
        }

        return await action(iframe, iframe.contentWindow);
    } finally {
        iframe.parentNode?.removeChild(iframe);
    }
}

export default withIframe;
